import type { StateCreator } from 'zustand';
import {
  setPatient,
  setPatientBasicInfo,
  setPatientContactDetails,
  setPatientIdentificationInfo,
  setPatientIhiVerification,
  setPatientRedFlagInfo,
} from './actions';
import {
  getPatient,
  getPatientBasicInfo,
  getPatientCode,
  getPatientContactDetails,
  getPatientId,
  getPatientIdentificationInfo,
  getPatientRedFlagInfo,
} from './selectors';
import type { BasicInfo, ContactDetails, IdentificationInfo, Patient, PatientSliceType, RedFlagInfo } from './types';

export const patientSlice: StateCreator<
  PatientSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  PatientSliceType
> = (set, get, store) => ({
  patient: {
    patientId: null,
    patientCode: null,
    needsIhiVerification: false,
    basicInfo: {
      firstName: null,
      lastName: null,
      dob: null,
      gender: null,
    },
    identificationInfo: {
      ihiNumber: null,
      ihiNumberStatus: null,
      ihiRecordStatus: null,
      medicareExpDate: null,
      medicareNumber: null,
      medicareRefNumber: null,
    },
    redFlagInfo: {
      hasRedFlag: false,
      redFlagComment: null,
    },
    contactDetails: {
      email: null,
      phone: null,
    },
  },
  getPatient: () => getPatient(get),
  getPatientId: () => getPatientId(get),
  getPatientCode: () => getPatientCode(get),
  getPatientBasicInfo: () => getPatientBasicInfo(get),
  getPatientIdentificationInfo: () => getPatientIdentificationInfo(get),
  getPatientRedFlagInfo: () => getPatientRedFlagInfo(get),
  getPatientContactDetails: () => getPatientContactDetails(get),
  setPatient: (attributes: Partial<Patient>) => setPatient(set, get, store)(attributes),
  setPatientBasicInfo: (attributes: BasicInfo) => setPatientBasicInfo(set, get, store)(attributes),
  setPatientContactDetails: (attributes: ContactDetails) => setPatientContactDetails(set, get, store)(attributes),
  setPatientIdentificationInfo: (attributes: IdentificationInfo) =>
    setPatientIdentificationInfo(set, get, store)(attributes),
  setPatientRedFlagInfo: (attributes: RedFlagInfo) => setPatientRedFlagInfo(set, get, store)(attributes),
  setPatientIhiVerification: (needsVerification: boolean) =>
    setPatientIhiVerification(set, get, store)(needsVerification),
});
